<template>
  <button
    type="button"
    class="inline-flex items-center gap-1 px-2 py-1 text-[11px] font-mono font-semibold rounded-lg border transition shrink-0"
    :class="badgeClass"
    :title="copyTitle"
    @click.stop="copyNumber"
  >
    <i class="mdi mdi-ticket-confirmation-outline text-[14px] shrink-0"></i>
    <span class="truncate">{{ ticketNumber }}</span>
    <i
      v-if="copied"
      class="mdi mdi-check text-[12px] shrink-0"
    ></i>
  </button>
</template>

<script setup>
import { ref, computed } from "vue";

const props = defineProps({
  ticketNumber: { type: String, required: true },
  statusClass: { type: String, default: "" },
  copyTitle: { type: String, default: "Copy ticket number" },
});

const copied = ref(false);
let copyTimer = null;

const badgeClass = computed(
  () =>
    props.statusClass ||
    "border-slate-200 bg-slate-50 text-slate-700 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100",
);

async function copyNumber() {
  try {
    await navigator.clipboard.writeText(props.ticketNumber);
    copied.value = true;
    if (copyTimer) clearTimeout(copyTimer);
    copyTimer = setTimeout(() => (copied.value = false), 1500);
  } catch {
    /* ignore */
  }
}
</script>
